export const SET_PLAYED_MATCHES = 'SET_PLAYED_MATCHES';
export const SET_NEW_HEAD_2_HEAD = 'SET_NEW_HEAD_2_HEAD';
export const SET_FILTERED_MATCHES = 'SET_FILTERED_MATCHES';
export const SET_FILTER_SURFACE = 'SET_FILTER_SURFACE';
export const SET_FILTER_YEAR = 'SET_FILTER_YEAR';
export const SET_FILTER_TOURNAMENT = 'SET_FILTER_TOURNAMENT';
export const INIT_DATA = 'INIT_DATA';
export const SET_INITIALIZED = 'SET_INITIALIZED';
export const SET_FILTERING = 'SET_FILTERING';
export const SET_CALCULATING = 'SET_CALCULATING';



// WEBPACK FOOTER //
// ./src/app/store/tennis/tennis.mutations.types.ts